module.exports = __webpack_public_path__ + "img/zh_action.1d5e71af.png";